import { InputNumber } from "antd";

type Props = {
  size?: "small" | "middle" | "large";
  variant?: "borderless" | "outlined" | "filled";
  value?: number | null;
  onChange?: ((value: number | null) => void) | undefined;
  readOnly?: boolean;
  disabled?: boolean;
  placeholder?: string;
};

export const MoneyInput = ({
  size,
  variant,
  onChange,
  value,
  readOnly,
  disabled,
  placeholder,
}: Props) => {
  const isEmpty = value === null || value === undefined;

  if (placeholder && isEmpty) {
    return <span className='money-input-placeholder'>{placeholder}</span>;
  }

  return (
    <InputNumber
      value={value ?? undefined}
      formatter={(v) =>
        v === undefined || v === null ? "" : `$ ${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      }
      parser={(v) => v?.replace(/\$\s?|(,*)/g, "") as unknown as number}
      size={size}
      variant={variant}
      onChange={onChange}
      readOnly={readOnly}
      disabled={disabled}
      placeholder={placeholder}
    />
  );
};
